// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tags-search-filter.tags .tags__selected-items{border-bottom:1px solid rgba(0,0,0,.42);min-height:30px}.tags-search-filter.tags .tags__input-placeholder{color:#9d9d9d;cursor:text;transform:translateY(3px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
